// extracted by mini-css-extract-plugin
export default {"gallery":"Projekty_gallery__m4mmk","photo":"Projekty_photo__U5sT+"};